import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, applyQueryString } from 'services';
import {
  ListSchedulingDocksActions as Actions,
  ListSchedulingDocksRequestAction as RequestAction,
} from 'store/ducks/scheduling';

export function* listSchedulingDocksRequest(action: any) {
  const { query, onSuccess, onFailure }: RequestAction = action;
  try {
    const url = applyQueryString('scheduling/docks', query);
    const { data } = yield call(api.get, url);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
